/*! rb-popup-sequence-v1 — one overlay at a time on first load: age gate, then the cookie notice,
 * then Digioh.
 *
 *   1. Age gate shows on load (rb-age-gate.js).
 *   2. Cookie notice is held by rb-cookie-hold.js and released 1.5s after the gate closes.
 *   3. Digioh's script is not requested until 0.8s after the cookie notice is answered.
 *
 * Digioh is gated at the script tag, not by hiding its boxes. A hidden Digioh popup still
 * dims the page and locks body scroll, so the only clean way to hold it is to not load it.
 * The script also carries the desktop campaign bar, so the bar arrives with the popups.
 *
 * A visitor who is already verified and has already answered the cookie notice has nothing
 * to sequence, so Digioh loads immediately for them, exactly as before.
 *
 * Fails open: the inline Digioh loader in theme.liquid only waits when this object exists, so
 * if this file never runs, Digioh loads on the old schedule.
 */
(function () {
  'use strict';

  if (window.rbPopupSeq) return;

  var GATE_TO_COOKIE_MS = 1500;
  var COOKIE_TO_DIGIOH_MS = 800;
  /* A notice that never shows within this window after release means Consentmo decided not to
     show one (region, prior consent it tracks elsewhere), so the step is treated as done. */
  var NOTICE_APPEAR_WINDOW_MS = 2000;
  /* A visitor who leaves the notice unanswered still gets Digioh eventually. */
  var NOTICE_IGNORED_MS = 8000;
  var POLL_MS = 500;

  function cookieAnswered() {
    return /(?:^|;\s*)cookieconsent_status=/.test(document.cookie || '');
  }

  function ageVerified() {
    if (window.rbAgeVerify) return window.rbAgeVerify.isVerified();
    try {
      return !!window.localStorage.getItem('rb_age_verified');
    } catch (err) {
      return false;
    }
  }

  var crawler = !!window.rbIsCrawler;
  var holdCookie = !crawler && !cookieAnswered();
  var deferDigioh = !crawler && (holdCookie || !ageVerified());

  var digiohLoader = null;
  var digiohWanted = false;
  var cookieDone = false;

  function loadDigioh() {
    digiohWanted = true;
    if (digiohLoader) {
      var run = digiohLoader;
      digiohLoader = null;
      run();
    }
  }

  function finishCookieStep() {
    if (cookieDone) return;
    cookieDone = true;
    if (deferDigioh) window.setTimeout(loadDigioh, COOKIE_TO_DIGIOH_MS);
  }

  function noticeOnScreen() {
    var host = document.querySelector('csm-cookie-consent');
    var root = host && host.shadowRoot;
    var bar = root && root.querySelector('.csm-cmp-bar');
    if (!bar) return false;
    var cs = window.getComputedStyle(bar);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    return bar.getBoundingClientRect().height > 0;
  }

  var watching = false;

  function watchNotice() {
    if (watching) return;
    watching = true;
    var started = Date.now();
    var seenAt = 0;
    var timer = window.setInterval(function () {
      if (cookieDone) {
        window.clearInterval(timer);
        return;
      }
      var now = Date.now();
      if (noticeOnScreen()) {
        if (!seenAt) seenAt = now;
        if (now - seenAt >= NOTICE_IGNORED_MS) finishCookieStep();
      } else if (seenAt || cookieAnswered() || now - started >= NOTICE_APPEAR_WINDOW_MS) {
        finishCookieStep();
      }
    }, POLL_MS);
  }

  document.addEventListener('visitorConsentCollected', finishCookieStep);
  document.addEventListener('rb:cookie-banner-released', watchNotice);

  if (!holdCookie) {
    /* Nothing to wait for on the cookie side; Digioh still waits for the gate if it shows. */
    document.addEventListener('rb:age-gate-closed', finishCookieStep);
  } else {
    /* Normally rb-cookie-hold.js starts the watch when it releases the notice. These cover
       that file failing, so Digioh is never held forever behind a release that never came. */
    var backstop = function () {
      window.setTimeout(watchNotice, GATE_TO_COOKIE_MS + POLL_MS);
    };
    document.addEventListener('rb:age-gate-closed', backstop);
    document.addEventListener('DOMContentLoaded', function () {
      if (!document.getElementById('rb-age-gate')) backstop();
    });
  }

  window.rbPopupSeq = {
    holdCookie: holdCookie,
    deferDigioh: deferDigioh,
    cookieDelayMs: GATE_TO_COOKIE_MS,
    /* Called by the inline Digioh tag in theme.liquid with its own loader. */
    whenDigiohAllowed: function (run) {
      if (!deferDigioh || digiohWanted) {
        run();
        return;
      }
      digiohLoader = run;
    },
  };
})();
